var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandAuthyStyleBrand = function SvgBrandAuthyStyleBrand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandAuthyStyleBrand__clip0_3952_113773)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F22E46",
    d: "M24 12c0 6.628-5.372 12-12 12S0 18.628 0 12 5.372 0 12 0s12 5.372 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.971 9.458 2.877 2.877a1.065 1.065 0 0 0 1.506-1.506l-2.877-2.877a5.38 5.38 0 0 0-7.546-.053q-.012.014-.026.027l-.027.026-.051.056a5.38 5.38 0 0 0 .104 7.49l2.878 2.877a1.065 1.065 0 0 0 1.507-1.506l-2.878-2.877a3.246 3.246 0 0 1-.026-4.56 3.246 3.246 0 0 1 4.56.026"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5B1B2",
    d: "M14.685 5.627a1.063 1.063 0 0 0 0 1.505l2.877 2.877a3.247 3.247 0 0 1 .025 4.56 3.246 3.246 0 0 1-4.558-.026l-2.877-2.877a1.065 1.065 0 1 0-1.507 1.506l2.877 2.877a5.38 5.38 0 0 0 7.49.105l.057-.052.025-.027.027-.027a5.379 5.379 0 0 0-.053-7.545l-2.877-2.876a1.064 1.064 0 0 0-1.506 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandAuthyStyleBrand__clip0_3952_113773"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandAuthyStyleBrand);
export { ForwardRef as ReactComponent };